/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Koreastudies18Inputs */

const en__field__enum_studyprograms_study_koreastudies18 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Koreastudies18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korea Studies`)
};

const de__field__enum_studyprograms_study_koreastudies18 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Koreastudies18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koreastudien`)
};

/**
* | output |
* | --- |
* | "Korea Studies" |
*
* @param {_Field__Enum_Studyprograms_Study_Koreastudies18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_koreastudies18 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Koreastudies18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Koreastudies18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_koreastudies18(inputs)
	return de__field__enum_studyprograms_study_koreastudies18(inputs)
});
export { _field__enum_studyprograms_study_koreastudies18 as "_field__enum_studyPrograms_STUDY_KOREASTUDIES" }